package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.ImportedDelivery
import com.milta.feature.route.domain.repository.RouteRepository

/** POST /api/v1/routes/import — parses an uploaded `.xlsx` into a delivery preview (DOM-02). */
class ImportRouteFileUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(fileBytes: ByteArray, fileName: String): List<ImportedDelivery> =
        repository.importRouteFile(fileBytes, fileName)
}
